/// <reference path="../../../../node_modules/@types/google.maps/index.d.ts" />

class GoogleMap {
	containerEl!: HTMLElement;
	map!: google.maps.Map;
	markers: google.maps.Marker[] = [];
	makerEls: HTMLElement[] = [];
	options: google.maps.MapOptions = {};

	constructor(containerEl: HTMLElement, mapOptions: google.maps.MapOptions = {}) {
		if (typeof google === "object" && typeof google.maps === "object") {
			this.containerEl = containerEl;
			this.options = mapOptions;

			this.init();
		}
		else {
			console.error("Google Map API key is not present!");
		}
	}

	init(): void {
		this.map = this.renderMap(this.containerEl, this.options);
		this.centerMap();
	}

	renderMap(mapEl: HTMLElement, mapOptions: google.maps.MapOptions = {}): google.maps.Map {
		const markerEls = mapEl.querySelectorAll('.marker');

		let args = <google.maps.MapOptions>{
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false
		};

		args = {...args, ...mapOptions};

		const map = new google.maps.Map(mapEl, args);

		markerEls.forEach(item => {
			this.addMarker(<HTMLElement>item, map);
		});

		return map;
	}

	addMarker(markerEl: HTMLElement, map: google.maps.Map): google.maps.Marker {

		const lat = Number.parseFloat(<string>markerEl.getAttribute('data-lat'));
		const lng = Number.parseFloat(<string>markerEl.getAttribute('data-lng'));

		const latlng = new google.maps.LatLng(lat, lng);
		const url = markerEl.getAttribute("data-url");

		const marker = new google.maps.Marker({
			position: latlng,
			map: map
		});

		const iconConfig = this.getMarkerIconConfig(markerEl);
		if (iconConfig) {
			marker.setIcon(iconConfig);
		}

		this.markers.push(marker);
		this.makerEls.push(markerEl);

		const html = markerEl.innerHTML;
		this.createInfoWindow(marker, html);

		if (url) {
			marker.addListener("click", () => {
				window.open(url);
			});
		}

		return marker;

	}

	createInfoWindow(marker: google.maps.Marker, html: string): void {
		if (html !== "") {
			const infowindow = new google.maps.InfoWindow({
				content: html
			});

			google.maps.event.addListener(marker, "click", () => {
				infowindow.open(this.map, marker);
			});
		}
	}

	centerMap(marker: google.maps.Marker|null = null, zoom: number = 8) {
		const bounds = new google.maps.LatLngBounds();

		if (marker === null) {
			this.markers.forEach(marker => {
				bounds.extend(<google.maps.LatLng>marker.getPosition());
			});
		}
		else {
			bounds.extend(<google.maps.LatLng>marker.getPosition());
		}

		if (this.markers.length === 1 || marker !== null) {
			this.map.setCenter(bounds.getCenter());
			this.map.setZoom(zoom);
		}
		else if (this.markers.length > 0) {
			this.map.fitBounds(bounds);
		}
	}

	getMarkerIconConfig(markerEl: HTMLElement): google.maps.Icon|null {
		return null;
	}

}

export default GoogleMap;
